// extracted by css-extract-rspack-plugin
export default {"content-wrapper":"StickyActionBarWrapper-module__content-wrapper--KDRO9","contentWrapper":"StickyActionBarWrapper-module__content-wrapper--KDRO9"};